import type { Fields as Campaign } from 'models/Campaign'
import React from 'react'
import AudienceBreakoutModal from 'scenes/CampaignCenter/Builder/Steps/Location/Shared/Review/components/Audience/components/AudienceBreakoutModal'
import Review from 'scenes/CampaignCenter/Builder/Steps/Shared/Review'
import AudienceContainer from 'scenes/CampaignCenter/Builder/Steps/Shared/Review/components/Audience'

type Props = {
  campaign: Campaign
  setCurrentStep: (step: string) => void
}

const PromoteReview: React.FC<Props> = props => {
  const { campaign, setCurrentStep } = props
  return (
    <Review
      campaign={campaign}
      setCurrentStep={setCurrentStep}
      audience={
        <AudienceContainer
          campaign={campaign}
          setCurrentStep={setCurrentStep}
          locationIds={campaign.config_target_location_ids}
          displayLocationDetails={true}
          renderAudienceBreakoutModal={props => (
            <AudienceBreakoutModal {...props} campaign={campaign} />
          )}
        />
      }
    />
  )
}

export default PromoteReview
